import Icon from 'veui/components/Icon'
import { IconMiniAppBaidu } from 'dls-icons-vue'

Icon.register('mini-app-baidu', IconMiniAppBaidu)
